import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface MapModalProps {
  open: boolean;
  onClose: () => void;
  address?: string;
  eventName: string;
  latitude?: string;
  longitude?: string;
}

const MapModal: React.FC<MapModalProps> = ({ open, onClose, address, eventName, latitude, longitude }) => {
  // Generate map URL based on whether we have coordinates or address
  let mapUrl: string;
  let searchQuery: string;
  
  if (latitude && longitude) {
    // Use coordinates for precise location
    mapUrl = `https://www.google.com/maps/embed/v1/view?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&center=${latitude},${longitude}&zoom=15`;
    searchQuery = `${latitude},${longitude}`;
  } else if (address) {
    // Fallback to address search
    const encodedAddress = encodeURIComponent(address);
    mapUrl = `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodedAddress}`;
    searchQuery = encodedAddress;
  } else {
    // Default fallback
    mapUrl = `https://www.google.com/maps/embed/v1/view?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&center=0,0&zoom=2`;
    searchQuery = '';
  }

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      PaperProps={{
        sx: {
          height: '80vh',
          maxHeight: '600px'
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        pb: 1
      }}>
        <Typography variant="h6">
          Location: {eventName}
        </Typography>
        <Button
          onClick={onClose}
          sx={{ minWidth: 'auto', p: 0.5 }}
        >
          <CloseIcon />
        </Button>
      </DialogTitle>
      <DialogContent sx={{ p: 0, flex: 1 }}>
        <Box sx={{ 
          width: '100%', 
          height: '100%', 
          position: 'relative',
          '& iframe': {
            border: 'none',
            width: '100%',
            height: '100%'
          }
        }}>
          <iframe
            src={mapUrl}
            title={`Map showing location for ${eventName}`}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button 
          onClick={onClose} 
          variant="outlined"
        >
          Close
        </Button>
        <Button 
          variant="contained"
          onClick={() => {
            if (latitude && longitude) {
              window.open(`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`, '_blank');
            } else if (address) {
              window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
            }
          }}
        >
          Open in Google Maps
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MapModal;
